import { render, staticRenderFns } from "./Stems.template.vue?vue&type=template&id=64f00c4c&scoped=true&"
var script = {}
import style0 from "./Stems.template.vue?vue&type=style&index=0&id=64f00c4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f00c4c",
  null
  
)

export default component.exports